'use client'

import type { PropsWithChildren } from 'react'
import { PlatformProvider as BasePlatformProvider, WebDefaults } from '@shared/ui/src/platform'

export default function PlatformProvider({ children }: PropsWithChildren) {
  return <BasePlatformProvider components={WebDefaults}>{children}</BasePlatformProvider>
}


